import {ToastContainer} from 'react-toastify';
import styled, {createGlobalStyle} from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';
import {globalDatePickerStyles} from 'components/ui-kit/DatePicker';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: Inter, sans-serif;
  }

  #root {
    width: 100%;
    min-width: 320px;
    min-height: 100vh;
  }

  h1 {
    font-size: 18px;
    margin: 10px 10px 20px;
  }
  
  ${globalDatePickerStyles};
`;

export const Background = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    pointer-events: none;
    background: #f0f4f7;
`;

export const ToastContainerRoot = styled(ToastContainer)`
    .Toastify {
        &__toast {
            border-radius: 3px;
        }
        &__toast--success {
            background: #90dd84;
        }
        &__toast-body {
            display: flex;
            justify-content: center;
        }
    }
`;
